import { getField, updateField } from 'vuex-map-fields';
import ValidationErrorHandler from "Classes/ValidationErrorHandler";

const getters = {
    getField
};

const state = {
    fieldsToSubmit: [
        'customer_type',
        'needs_customization',
        'is_non_profit',
        'is_exempt_from_sales_tax',
        'first_name',
        'last_name',
        'email',
        'phone',
        'phone_extension',
        'job_title',
        'timezone',

        'company_name',
        'company_invoice_email',
        'company_address_1',
        'company_address_2',
        'company_city',
        'company_state_id',
        'company_postal_code',
        'company_country_id',
        'company_website',
        'company_industry',
        'company_reseller_id',
        'payment_type_id',
        'tax_exemption_signed_date',
        'tax_exemption_expiration_date',
        'currently_working_with_swell_member',
        'associated_sales_rep',
        'how_did_you_hear_about_us',
        'expected_order_qty',
        'products_of_interest',
        'desired_delivery_date',
        'additional_information',
    ],

    // Pre-filled for v-model on an empty application on the front
    // Essentially will get merged with a submitted application on edit page
    form: {
        user_name: '',
        customer_type: '',
        needs_customization: '',
        is_non_profit: '',
        is_exempt_from_sales_tax: '',

        first_name: '',
        last_name: '',
        job_title: '',
        email: '',
        phone: '',
        phone_extension: '',
        timezone: '',

        company_name: '',
        company_invoice_email: '',
        company_address_1: '',
        company_address_2: '',
        company_city: '',
        company_state_id: '',
        company_postal_code: '',
        company_country_id: 1,
        company_website: '',
        company_industry: '',
        company_reseller_id: '',

        agreed_terms: '',

        tax_exemption_signed_date: '',
        tax_exemption_expiration_date: '',

        currently_working_with_swell_member: '',
        associated_sales_rep: '',
        how_did_you_hear_about_us: '',

        expected_order_qty: '',
        products_of_interest: [],
        desired_delivery_date: '',
        additional_information: ''
    },

    existing_company: {},
    company_exists: false,
    existing_application: null,
    states: [],
    countries: [],
    customer_types: [
        {text: 'Corporate Gifts & Special Events', value: 'Corporate Gifts & Special Events'},
        {text: 'Retail/Store', value: 'Retail/Store'},
        {text: 'Promotional Distributor (ASI/PPAI)', value: 'Promotional Distributor (ASI/PPAI)'},
    ],
    wholesale_industries: [
        {text: 'Active Wear', value: 'Active Wear'},
        {text: 'Beauty/Cosmetics', value: 'Beauty/Cosmetics'},
        {text: 'Book Store', value: 'Book Store'},
        {text: 'Catalog', value: 'Catalog'},
        {text: 'Charity', value: 'Charity'},
        {text: 'Childrens', value: 'Childrens'},
        {text: 'Coffee/Tea Specialty', value: 'Coffee/Tea Specialty'},
        {text: 'Fashion/Apparel', value: 'Fashion/Apparel'},
        {text: 'Furniture', value: 'Furniture'},
        {text: 'Gift', value: 'Gift'},
        {text: 'Gourmet/Wine', value: 'Gourmet/Wine'},
        {text: 'Health/Grocery', value: 'Health/Grocery'},
        {text: 'Home Decor/Kitchen', value: 'Home Decor/Kitchen'},
        {text: 'Hotel Boutique', value: 'Hotel Boutique'},
        {text: 'Jewelry', value: 'Jewelry'},
        {text: 'Museum/Gallery', value: 'Museum/Gallery'},
        {text: 'Press/TV', value: 'Press/TV'},
        {text: 'School/University', value: 'School/University'},
        {text: 'Spa/Salon', value: 'Spa/Salon'},
        {text: 'Sporting/Gym', value: 'Sporting/Gym'},
        {text: 'Swim/Resort', value: 'Swim/Resort'},
        {text: 'Technology', value: 'Technology'},
        {text: 'Trade', value: 'Trade'},
        {text: 'Travel', value: 'Travel'},
        {text: 'Other', value: 'Other'}
    ],
    industries: [
        {text: 'Arts', value: 'Arts'},
        {text: 'Communications', value: 'Communications'},
        {text: 'Construction', value: 'Construction'},
        {text: 'Consulting', value: 'Consulting'},
        {text: 'Education', value: 'Education'},
        {text: 'Entertainment', value: 'Entertainment'},
        {text: 'Finance', value: 'Finance'},
        {text: 'Government', value: 'Government'},
        {text: 'Health', value: 'Health'},
        {text: 'Hospitality', value: 'Hospitality'},
        {text: 'Humanitarian', value: 'Humanitarian'},
        {text: 'Insurance', value: 'Insurance'},
        {text: 'Legal Services', value: 'Legal Services'},
        {text: 'Manufacturing', value: 'Manufacturing'},
        {text: 'Publishing', value: 'Publishing'},
        {text: 'Real Estate', value: 'Real Estate'},
        {text: 'Retail Trade', value: 'Retail Trade'},
        {text: 'Services', value: 'Services'},
        {text: 'Sports', value: 'Sports'},
        {text: 'Technology', value: 'Technology'},
        {text: 'Transportation', value: 'Transportation'},
        {text: 'Utilities', value: 'Utilities'},
        {text: 'Wholesale', value: 'Wholesale'},
        {text: 'Other', value: 'Other'}
    ],
    howDidYouHearAboutUsOptions: [
        {text: 'Facebook/Instagram Ad', value: 'Facebook/Instagram Ad'},
        {text: 'Google', value: 'Google'},
        {text: 'LinkedIn', value: 'LinkedIn'},
        {text: 'Outdoor Ad', value: 'Outdoor Ad'},
        {text: 'Television', value: 'Television'},
        {text: 'Friend/Colleague', value: 'Friend/Colleague'},
        {text: 'Other', value: 'Other'},
    ],
    ValidationErrorHandler: new ValidationErrorHandler(),
    salesReps: [],
    order_qty_options: [
        'Less than 48',
        '49 - 100',
        '100 - 499',
        '500 - 999',
        '1,000+'
    ],
    products_of_interest_options: [
        'Original Bottle',
        'Traveler',
        'Tumbler',
        "S'well Eats",
        "Barware",
        "Drink Chillers",
        "Haven't Decided",
        "Other",
    ]
};

const mutations = {
    updateField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};